import React from 'react';
import CanduLogo from '../../images/candu_logo.svg';

import SEO from '../SEO';

const Error = (props) => (
  <div className="error-container">
    <SEO {...props.meta} />
    <div className="card error-wrapper">
      <div className="error-row">
        <img src={CanduLogo} alt="candu logo" />
      </div>
      <div className="error-row column">
        <span>{props.heading}</span>
        <span>{props.message}</span>
      </div>
      <div className="error-row right">
        <button type="button" onClick={() => window.location.replace('/')} className="button">
          Back to front page
        </button>
      </div>
    </div>
  </div>
);
export default Error;
